module.exports = __webpack_public_path__ + "static/media/percentage_icon.9d21121f.svg";